import successHandler from "../../handlers/successHandler";
import errorHandler from "../../handlers/errorHandler";
import { businessVerificationService } from "../../services/businessVerifiation.service";
import actionType from "./businessVerificationTypes";

export const editBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationService.editBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const storeBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationService.storeBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const filterBusinessVerificationAction =
  (payLoad, page) => async (dispatch) => {
    try {
      dispatch({ type: actionType["FILTERING"], payLoad: true });
      const response = await businessVerificationService.filterBusinessVerification(
        payLoad,
        page
      );
      dispatch({ type: actionType["FILTERING"], payLoad: false });
      dispatch({
        type: actionType["FILTER_VERIFICATION"],
        payLoad: response,
      });
      return response;
    } catch (error) {
      dispatch({ type: actionType["FILTERING"], payLoad: false });
    }
  };

export const searchBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["SEARCHING"], payLoad: true });
    const response = await businessVerificationService.searchBusinessVerification({
      ...payLoad,
    });
    dispatch({ type: actionType["SEARCHING"], payLoad: false });
    dispatch({
      type: actionType["SEARCH_VERIFICATION"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({ type: actionType["SEARCHING"], payLoad: false });
  }
};

export const showABusinessVerification = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["LOADING"], payLoad: true });
    const response = await businessVerificationService.showABusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["LOADING"], payLoad: false });
    dispatch({
      type: actionType["SHOW_A_VERIFICATION"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({ type: actionType["LOADING"], payLoad: false });
    errorHandler(error, true);
    throw new Error("");
  }
};

export const showMyBusinessVerification = () => async (dispatch) => {
  try {
    dispatch({ type: actionType["LOADING"], payLoad: true });
    const response = await businessVerificationService.showMyBusinessVerification();
    dispatch({ type: actionType["LOADING"], payLoad: false });
    dispatch({
      type: actionType["SHOW_MY_VERIFICATION"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({ type: actionType["LOADING"], payLoad: false });
    if (error?.response?.status !== 404) {
      errorHandler(error, true);
      throw new Error("");
    }
  }
};

export const verifyBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationService.verifyBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const rejectBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationService.rejectBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};
